import { render, staticRenderFns } from "./memberBenefitsRecord.vue?vue&type=template&id=6c6b65d4&scoped=true"
import script from "./memberBenefitsRecord.vue?vue&type=script&lang=js"
export * from "./memberBenefitsRecord.vue?vue&type=script&lang=js"
import style0 from "./memberBenefitsRecord.vue?vue&type=style&index=0&id=6c6b65d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b65d4",
  null
  
)

export default component.exports